import _isArray from "lodash/isArray";

var normalizeHandlers = function normalizeHandlers(handlers) {
  return _isArray(handlers) ? handlers : [handlers];
};

export default normalizeHandlers;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/eventStack/normalizeHandlers.js
// module id = 2847
// module chunks = 0